import Joi from 'joi'
import errorsResolver from '../../../../../validation/schemeUtils'
import { documentTypes } from '../../../../../helpers/data-constants'

const LAST_NAME_LENGTH = 100;
const FIRST_NAME_LENGTH = 100;
const MIDDLE_NAME_LENGTH = 100;
const AUTHORITY_LENGTH = 400
const DOCUMENT_NUMBER_LENGTH = 40
const BASE_CLOSURE = 500
const WHO_HAS_TO = 200
const PERSONAL_NUMBER = 20
const documentsType = [...documentTypes.residency, documentTypes.another[1]]

const documentAny = Joi.string()
    .required()
    .when('documentType', { is: "Иной документ", then: Joi.allow('') })
    .max(DOCUMENT_NUMBER_LENGTH)
    .pattern(new RegExp('^[a-zA-Z0-9]*$'))
    .error(errorsResolver({
        max: `Номер документа должен быть не более ${DOCUMENT_NUMBER_LENGTH} символов`,
        required: `Номер документа обязательное поле`,
        pattern: `Номер документа содержит некорректные символы`
    }))

export const buyThirdPersonSchema = Joi.object({
    lastName: Joi.string()
        .max(LAST_NAME_LENGTH)
        .required()
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ\\- ]*$'))
        .error(errorsResolver({
            max: `Фамилия должна быть до ${LAST_NAME_LENGTH} символов`,
            required: `Фамилия обязательное поле`,
            pattern: `Фамилия содержит некорректные символы`
        })),
    firstName: Joi.string()
        .max(FIRST_NAME_LENGTH)
        .required()
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ\\- ]*$'))
        .error(errorsResolver({
            max: `Имя должно быть до ${LAST_NAME_LENGTH} символов`,
            required: `Имя обязательное поле`,
            pattern: `Имя содержит некорректные символы`
        })),
    middleName: Joi.string()
        .max(MIDDLE_NAME_LENGTH)
        .allow('')
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ\\- ]*$'))
        .error(errorsResolver({
            max: `Отчество должно быть до ${MIDDLE_NAME_LENGTH} символов`,
            pattern: `Отчество содержит некорректные символы`
        })),
    documentType: Joi.string()
        .required().valid(...documentsType)
        .error(errorsResolver({
            required: `Тип документа обязательное поле`,
            values: `Тип документа обязательное поле`
        })),
    documentNumberClosure: Joi.alternatives().conditional('documentType', {
        switch: [{
            is: "Паспорт", then: Joi.alternatives().conditional(Joi.ref('citizenship.label'),
                {
                    is: "Беларусь",
                    then: Joi.string()
                            .required()
                            .max(9)
                            .pattern(new RegExp('^[A-Z]{2}[0-9]{7}$'))
                            .error(errorsResolver({
                                max: `Номер документа должен быть не более ${DOCUMENT_NUMBER_LENGTH} символов`,
                                required: `Номер документа обязательное поле`,
                                pattern: `Номер документа в неверном формате`
                            })),
                    otherwise: documentAny
                })
        }, {
            is: "Вид на жительство", then: Joi.alternatives().conditional(Joi.ref('citizenship.label'),
                {
                    is: "Беларусь",
                    then:
                        Joi.string()
                            .required()
                            .max(DOCUMENT_NUMBER_LENGTH)
                            .pattern(new RegExp('^[A-Z]{2}[0-9]{7}$'))
                            .error(errorsResolver({
                                max: `Номер документа должен быть до ${DOCUMENT_NUMBER_LENGTH} символов`,
                                required: `Номер документа обязательное поле`,
                                pattern: `Номер документа в неверном формате`
                            })),
                    otherwise: documentAny
                }),
            otherwise: documentAny
        }]
    }
    ),
    citizenship: Joi.alternatives().conditional(Joi.object(), {
        then: Joi.object({
            label: Joi.string()
                .required('')
                .error(errorsResolver({
                    required: `Гражданство обязательное поле`
                })),
            value: Joi.number()
                .error(errorsResolver({
                    number: `Должно быть число`
                }))
        })
            .invalid(null)
            .required()
            .when('documentType', { is: "Иной документ", then: Joi.allow('') })
            .error(errorsResolver({
                invalid: `Гражданство обязательное поле`,
                required: `Гражданство обязательное поле`
            })),
        otherwise: Joi.string()
            .required()
            .invalid(null)
            .error(errorsResolver({
                invalid: `Гражданство обязательное поле`,
                required: `Гражданство обязательное поле`
            }))
    }),
    startDate: Joi.date()
        .required()
        .iso().less("now")
        .error(errorsResolver({
            dateLess: `Дата выдачи должна быть до сегодняшнего числа`,
            dateFormat: `Некорректная дата выдачи`
        })),
    authority: Joi.string()
        .required()
        .max(AUTHORITY_LENGTH)
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.\\- ]*$'))
        .error(errorsResolver({
            required: `Орган, выдавший документ обязательное поле`,
            pattern: `Орган, выдавший документ содержит некорректные символы`,
            max: `Орган, выдавший документ должен быть меньше ${AUTHORITY_LENGTH} символов`
        })),
    baseClosure: Joi.string()
        .max(BASE_CLOSURE)
        .required()
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\\\(*/,-.№") ]*$'))
        .error(errorsResolver({
            max: `Основание должно быть до ${BASE_CLOSURE} символов`,
            required: `Основание обязательное поле`,
            pattern: `Основание содержит некорректные символы`
        })),
    personalNumber: Joi.alternatives()
        .conditional('documentType', {
            is: "Паспорт",
            then: Joi.alternatives()
                .conditional(Joi.ref('citizenship.label'),
                    {
                        is: "Беларусь",
                        then: Joi.string()
                            .required()
                            .max(PERSONAL_NUMBER)
                            .pattern(new RegExp('^\\d\\d\\d\\d\\d\\d\\d[A-ZА-Я]\\d\\d\\d[A-ZА-Я]{2}\\d$'))
                            .error(errorsResolver({
                                max: `Персональный номер должен быть до ${PERSONAL_NUMBER} символов`,
                                required: `Персональный номер обязательное поле`,
                                pattern: `Персональный номер в неверном формате`
                            })),
                        otherwise: Joi.string()
                            .allow('')
                            .max(PERSONAL_NUMBER)
                            .error(errorsResolver({
                                max: `Персональный номер должен быть до ${PERSONAL_NUMBER} символов`,
                            }))
                    }),
            otherwise: Joi.string()
                .allow('')
                .max(PERSONAL_NUMBER)
                .error(errorsResolver({
                    max: `Персональный номер должен быть до ${PERSONAL_NUMBER} символов`,
                }))
        }),
    whoHasTo: Joi.string()
        .max(WHO_HAS_TO)
        .allow('')
        .pattern(new RegExp('^[\\s\\S]*$'))
        .error(errorsResolver({
            max: `Кем приходится должно быть до ${WHO_HAS_TO} символов`,
        })),
})
